// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eQ-z","hovered":"fQ-z","hoverImage":"gQ-z","mainImage":"hQ-z","imageNoBackground":"iQ-z","fullSizeImage":"jQ-z"};